/* eslint-disable object-shorthand */

export var PACKAGE_BUILD_DATE = '2026-11-05T07:36:18.510Z';
export var PACKAGE_NAME = 'invision-customercare';
export var PACKAGE_VERSION = '27.1.10000-2703567';
export default {
  PACKAGE_BUILD_DATE: PACKAGE_BUILD_DATE,
  PACKAGE_NAME: PACKAGE_NAME,
  PACKAGE_VERSION: PACKAGE_VERSION
};